import { useMutation } from '@tanstack/react-query'

import {
  ApiPatchParams,
  ApiPatchRequestBody,
  ApiPatchResponse,
} from './helpers'
import { httpClient } from './http-client'

export function useLinkProjectToFolder() {
  return useMutation({
    async mutationFn(
      payload: ApiPatchParams<'/projects/{projectId}'>['path'] &
        Omit<ApiPatchRequestBody<'/projects/{projectId}'>, 'id'>
    ) {
      return httpClient.patch<ApiPatchResponse<'/projects/{projectId}'>>(
        `/projects/${payload.projectId}`,
        { folderId: payload.folderId ?? null }
      )
    },
  })
}
